export enum InspectionPlanTaskStatus {
  Recommended = 1,
  Active = 2,
  Closed = 3,
  Rejected = 4
}
